<script>
import { configure, extend, localize } from 'vee-validate'
import {
  required,
  min,
  max,
  confirmed,
  min_value,
  max_value,
  length
} from 'vee-validate/dist/rules'

import fa from 'vee-validate/dist/locale/fa.json'
import en from 'vee-validate/dist/locale/en.json'

import { PLATE_CHARACTER_OPTIONS } from '@/constants/options'

export default {
  name: 'ValidationMixin',
  mounted() {
    configure({
      classes: {
        invalid: 'invalid'
      }
    })

    this.extedRules()

    localize({
      en,
      fa
    })

    localize('fa')
  },
  methods: {
    extedRules() {
      extend('required', required)
      extend('min', min)
      extend('max', max)
      extend('min_value', min_value)
      extend('max_value', max_value)
      extend('length', length)

      extend('confirmed', {
        ...confirmed,
        message: (fieldName, { target }) =>
          this.$t('validation.confirmed', { fieldName, target })
      })

      extend('mobile', {
        validate: (value) =>
          String(value).match(/^(0|\+98|0098)9[0-9]{9}$/g) !== null,
        message: (fieldName) => this.$t('validation.invalid', { fieldName })
      })

      extend('phone', {
        validate: (value) =>
          String(value).match(/^((0|\+98|0098)[1-9]{2})?[1-9][0-9]{3,7}$/g) !==
          null,
        message: (fieldName) => this.$t('validation.invalid', { fieldName })
      })

      extend('national-id', {
        validate: (value) => {
          value = String(value)
          if (
            !/^[0-9]{10}$/.test(value) ||
            value === '0000000000' ||
            value === '1111111111' ||
            value === '2222222222' ||
            value === '3333333333' ||
            value === '4444444444' ||
            value === '5555555555' ||
            value === '6666666666' ||
            value === '7777777777' ||
            value === '8888888888' ||
            value === '9999999999'
          )
            return false
          const check = parseInt(value[9])
          let sum = 0
          let i
          for (i = 0; i < 9; ++i) {
            sum += parseInt(value[i]) * (10 - i)
          }
          sum %= 11
          return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11)
        },
        message: (fieldName) => this.$t('validation.invalid', { fieldName })
      })

      extend('email', {
        validate: (value) =>
          value.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
          ) !== null,
        message: (fieldName) => this.$t('validation.invalid', { fieldName })
      })

      extend('plate_iran', {
        validate: (value) => {
          if (value !== null && typeof value === 'object') {
            return value.iran ? String(value.iran).length === 2 : true
          }
          return false
        },
        message: () =>
          this.$t('validation.invalid', {
            fieldName: this.$t('forms.plateIranNumber')
          })
      })

      extend('plate_right', {
        validate: (value) => {
          if (value !== null && typeof value === 'object') {
            return value.right ? String(value.right).length === 3 : true
          }
          return false
        },
        message: () =>
          this.$t('validation.invalid', {
            fieldName: this.$t('forms.plateRightNumber')
          })
      })

      extend('plate_character', {
        validate: (value) => {
          if (value !== null && typeof value === 'object') {
            return value.character
              ? PLATE_CHARACTER_OPTIONS.map((option) => option.value).includes(
                  value.character
                )
              : true
          }
          return false
        },
        message: () =>
          this.$t('validation.invalid', {
            fieldName: this.$t('forms.plateCharacter')
          })
      })

      extend('plate_left', {
        validate: (value) => {
          if (value !== null && typeof value === 'object') {
            return value.left ? String(value.left).length === 2 : true
          }
          return false
        },
        message: () =>
          this.$t('validation.invalid', {
            fieldName: this.$t('forms.plateLeftNumber')
          })
      })

      extend('required_plate', {
        validate: (value) => {
          if (value === null || typeof value !== 'object') return false

          return !value.iran || !value.right || !value.character || !value.left
            ? false
            : true
        },
        message: (fieldName) => this.$t('validation.required', { fieldName })
      })
    }
  }
}
</script>
